import { createReducer } from '@reduxjs/toolkit'

import { IBonusSystemState } from '../types'

const initialState: IBonusSystemState['data'] = {}

export default createReducer(initialState, () => {})
